import type { ConstantCase } from 'string-ts'
import { constantCase } from 'string-ts'

export function createEnum<const T extends readonly string[]>(...args: T | [T]) {
  const values = (Array.isArray(args[0]) ? args[0] : args) as T

  const enumObj = Object.fromEntries(values.map((val) => [constantCase(val), val])) as {
    [K in T[number] as ConstantCase<K>]: K
  }

  return enumObj as typeof enumObj & {
    __type: T[number]
  }
}
